import { z } from 'zod'
import { stringSchema } from './common'

export const siteSchema = z.object({
  id: stringSchema.min(1),
  name: stringSchema.min(1),
  phoneNumber: stringSchema.min(1).nullish(),
  emailAddress: stringSchema.min(1).nullish(),
  address: stringSchema.min(1).nullish(),
  googleAnalyticsId: stringSchema.nullish(),
  googleGtmId: stringSchema.nullish(),
  scriptSources: stringSchema.nullish(),
  scriptSources: z.array(z.string()).nullish(),
  scriptBodies: z.array(z.string()).nullish(),
  facebookAnalyticsId: stringSchema.nullish(),
  facebookLink: stringSchema.nullish(),
  instagramLink: stringSchema.nullish(),
  tiktokLink: stringSchema.nullish(),
  youtubeLink: stringSchema.nullish(),
  trustPilotLink: stringSchema.nullish(),
  tripAdvisorLink: stringSchema.nullish(),
  ticketSupplierDescription: stringSchema.nullish(),
  hotelsEnabled: z.boolean().default(true),
  deviceTrackingEnabled: z.boolean().default(true),
  // Public deals page gate (BOAT-1859); ships OFF, so default false.
  dealsPageEnabled: z.boolean().default(false),
  // Cloudflare Turnstile on checkout (BOAT-2010). Null = switched off. The CMS
  // decides server-side whether an order needs a token; this only says when to
  // show the widget.
  turnstile: z.object({
    siteKey: z.string().min(1),
    scope: z.enum(['gift_cards', 'all']),
  }).nullish(),
  currency: z.object({
    code: stringSchema.min(1).toLowerCase(),
    name: stringSchema.min(1),
    roundUp: z.number()
  }),
  links: z.object({
    terms: stringSchema.min(1).nullish(),
  }),
})
